import React from 'react'
import Collection from '../common/collection'

function CollectionC({ props }) {
  return (
    <Collection
      alt="Maquinaria"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria19.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria22.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria23.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria38.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria39.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria40.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria68.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria71.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/3.+maquinaria72.jpg',
      ]}
    />
  )
}


export default CollectionC
